module.exports = __webpack_public_path__ + "img/tilda.1711594f.svg";